module.exports = function getResource(label, vars = []) {
    const resources = {
        shippingAndHandling: 'Expédition et manutention',
        discounts: 'Réductions',
        giftWrap: 'Emballage-cadeau',
        bagFee: 'Frais de sac',
        specialFee: 'Frais spéciaux',
        gstOrHst: 'TPS/TVH estimées',
        pst: 'TVP estimée',
        tax: 'Taxes estimées',
        storeCreditRedeemed: 'Crédit au compte',
        giftCardRedeemed: 'Carte-cadeau utilisée',
        eGiftCardRedeemed: 'Carte-cadeau électronique utilisée'
    };

    return resources[label];
};
